common.View.create('canvas.blocks.custom.slider.Block', {

    onDOMLoad()
    {
        this.initSlider();
    },

    initSlider()
    {
        this.element.find('.owl-carousel')
            .owlCarousel({
                loop: false,
                margin: 30,
                nav: this.element.find('.owl-carousel').data('show-navigation'),
                dots: true,
                autoplay: !this.element.find('.owl-carousel').data('show-navigation'),
                autoplayTimeout: 7000,
                items: 1,
            });

    }
});
